import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { COOKIES } from '../../_shared/constants/cookies';
import RetailToolsModal from '../../components/RetailToolsModal';
import useFeatureFlags from '../../_shared/hooks/useFeatureFlags';
import FEATURE_FLAGS from '../../_shared/constants/featureFlags';
import navigateBack from '../../_shared/helpers/navigateBack';
import MixpanelService from '../../services/MixpanelService';
import mixpanelConfig from '../../_shared/constants/mixpanelConfig';

const RetailTools = ({ isOmp }) => {
  const history = useHistory();
  const mixpanelService = MixpanelService.get();

  const isTIAHWhiteLabelEnabled = useFeatureFlags(
    FEATURE_FLAGS.IS_TIAH_WHITE_LABEL_ENABLED
  );

  useEffect(() => {
    mixpanelService.track(mixpanelConfig.names.accessRetailToolsPage);
  }, [mixpanelService]);

  return (
    <>
      {isTIAHWhiteLabelEnabled && (
        <RetailToolsModal
          testId="retailToolsSettingPage"
          isModalOpen
          isOmp={isOmp}
          closeHandler={() =>
            navigateBack(COOKIES.GO_BACK_FROM_TR5_SETTING, history)
          }
        />
      )}
    </>
  );
};

export default RetailTools;
